// 老人信息接口
export interface ElderInfo {
  name: string;
  gender: "男" | "女" | "未知";
  age?: number;
  identityName: string;
}

// AI总结接口
export interface AiSummary {
  contentSummary: string;
  actionAdvice: string;
}

// 结论记录接口
export interface ConclusionRecord {
  item: string;
  content: string;
  status: number;
  risks: string[];
}

// 反馈信息接口
export interface Feedback {
  comment?: string;
  attachments?: string[];
}

// 总体结论接口
export interface OverallConclusion {
  status: number; // 1-一切安好；2-建议关注；3-危险警告
  statusName: string; // 状态名称
  comment: string; // 结论依据性描述
  risks: string[]; // 风险数组
}

// 待审核报告接口
export interface VisitReportForReview {
  id: number;
  staffId?: number;
  staffName?: string;
  staffGender?: "男" | "女" | "未知";
  staffAge?: number;
  staffPhone?: string;
  staffAddress?: string;
  customerId?: number;
  customerName?: string;
  customerPhone?: string;
  elderInfo: ElderInfo[];
  elderPhone?: string;
  elderAddress?: string;
  startAt?: string;
  endAt?: string;
  durationMinutes?: number;
  chatRecordUrl?: string;
  aiSummary: AiSummary;
  overallConclusion?: OverallConclusion; // 总体结论
  conclusions: ConclusionRecord[];
  requirement?: string;
  feedback?: Feedback;
  createdAt: string;
  reviewedAt: string;
}

// 报告状态枚举
export enum VisitReportState {
  PENDING_REVIEW = 1, // 待审核
  APPROVED = 2, // 审核通过
  REJECTED = 3, // 审核不通过
}

// 查询参数接口
export interface ReviewReportsQuery {
  customerName?: string;
  elderName?: string;
  staffName?: string;
  startDate?: string;
  endDate?: string;
  reviewedStartDate?: string;
  reviewedEndDate?: string;
  state?: VisitReportState; // 报告状态
  page?: number;
  limit?: number;
}

// 分页响应接口
export interface PaginatedResponse<T> {
  success: boolean;
  data: {
    items: T[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
  };
  timestamp: string;
}

// API响应接口
export interface ApiResponse<T> {
  success: boolean;
  data: T;
  timestamp: string;
}
